export default Object.freeze({
    DOG: {
        id: 1,
        description: 'Cachorro',
        icon: require("../../public/img/dog-icon.svg"),
        plural: 'Cães'

    },
    CAT: {
        id: 2,
        description: 'Gato',
        icon: require("../../public/img/cat-icon.svg"),
        plural: 'Gatos'
    },
    WORDS_CONNECTOR: ' e ',
    getAnimalIcon(id) {
        if (id == this.DOG.id) return this.DOG.icon;
        return this.CAT.icon;
    },
    getAnimalDescription(id) {
        if (id == this.DOG.id) return this.DOG.description;
        return this.CAT.description;
    },
    getAnimalPlural(id) {
        if (id == this.DOG.id) return this.DOG.plural;
        else if (id == this.CAT.id) return this.CAT.plural;
        return this.DOG.plural + this.WORDS_CONNECTOR + this.CAT.plural;
    },
    getAllowedAnimals(animals) {
        let allowedAnimals = '';
        if (animals && animals.length) {
            allowedAnimals = this.getAnimalPlural(animals[0]);
            if (animals.length == 2) {
                allowedAnimals += this.WORDS_CONNECTOR + this.getAnimalPlural(animals[1]);
            }
        }
        return allowedAnimals;
    }
});